import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface RefundPolicyModalProps {
  onClose: () => void;
}

export default function RefundPolicyModal({ onClose }: RefundPolicyModalProps) {
  const { t } = useTranslation(['booking', 'refund']);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={onClose} />
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-4">
          <h3 className="text-lg font-semibold text-gray-900">
            {t('booking:consent.refundPolicy.modalTitle')}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Policy content */}
        <div className="p-4">
          <div className="space-y-3 text-gray-700">
            <div className="flex gap-3">
              <span className="text-primary font-bold shrink-0">•</span>
              <p className="text-sm">{t('refund:policies.noRefund24h')}</p>
            </div>
            <div className="flex gap-3">
              <span className="text-primary font-bold shrink-0">•</span>
              <p className="text-sm">{t('refund:policies.sickPolicy')}</p>
            </div>
            <div className="flex gap-3">
              <span className="text-primary font-bold shrink-0">•</span>
              <p className="text-sm">{t('refund:policies.hostCancel')}</p>
            </div>
            <div className="flex gap-3">
              <span className="text-primary font-bold shrink-0">•</span>
              <p className="text-sm">{t('refund:policies.refundTiming')}</p>
            </div>
          </div>

          {/* Close button */}
          <div className="mt-6">
            <button
              onClick={onClose}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-dark"
            >
              {t('refund:back')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
